<template>
  <div class="page">
    <div class="row">
      <div class="text-center col-12">
        <h4 class="m-3">Termo de Consentimento do Usuário</h4>
        <PDFViewer :source="urlTermo" style="height: 45vw; width: 75vw" />
      </div>
    </div>
    <div class="row mt-3">
      <div class="col-12" style="text-align: right">
        <b-button variant="danger" class="me-1">
          <i class="mdi mdi-cancel font-size-16 align-middle"></i>
          Recusar
        </b-button>

        <b-button variant="success" @click="aceitar()">
          <i class="mdi mdi-check font-size-16 align-middle"></i>
          Aceitar
        </b-button>
      </div>
    </div>
  </div>
</template>
<script>
import PDFViewer from 'pdf-viewer-vue/dist/vue2-pdf-viewer'

export default {
  components: {
    PDFViewer
  },
  data() {
    return {
      user: {},
      urlTermo: "",
    };
  },
  created() {
    this.user = this.$store.state.me;
    console.log("Morreu aqui ein:", this.user);
    this.buscarTermo();
  },
  methods: {
    buscarTermo() {
      this.loading = true;
      const isErp = this.user && this.user.user_erp;
      const endpoint = isErp ? "api/lgpd/buscarTermoErp/" : "api/lgpd/buscarTermo/";
      const config = {
        responseType: "blob"
      };
      if (isErp && this.$store.state.access_token) {
        config.headers = { Authorization: `Bearer ${this.$store.state.access_token}` };
      }
      this.$http
        .get(endpoint + this.user.nr_docto, config)
        .then((response) => {
          var blob = new Blob([response.data], {
            type: "application/pdf",
          });
          this.urlTermo = window.URL.createObjectURL(blob);
        });
    },

    aceitar() {
      const isErp = this.user && this.user.user_erp;
      const endpoint = isErp ? "api/lgpdErp/aprovaTermoErp" : "api/lgpd/aprovaTermo";
      const config = {};
      if (isErp && this.$store.state.access_token) {
        config.headers = { Authorization: `Bearer ${this.$store.state.access_token}` };
      }
      this.$http
        .post(endpoint, {
          SqTipoDocumentoJuridico: 4,
          Cpf: this.user.nr_docto,
          Consentiu: 1,
        }, config)
        .then(() => {
          this.$store.commit("VALIDA_TERMO_LGPD", true);
          this.verificaDocumentoAssembleia();
        });
    },

    verificaDocumentoAssembleia() {
      const isErp = this.user && this.user.user_erp;
      const endpoint = isErp ? "api/reuniaoErp/verificarTermoErp" : "api/reuniao/verificarTermo";
      const config = {};
      if (isErp && this.$store.state.access_token) {
        config.headers = { Authorization: `Bearer ${this.$store.state.access_token}` };
      }
      this.$http
        .get(endpoint, config)
        .then((response) => {
          const sq_upload = response.data.sq_upload;
          if (sq_upload !== null && sq_upload !== undefined && sq_upload !== '' && sq_upload !== 'null' && !isNaN(Number(sq_upload))) {
            this.$store.commit("VALIDA_TERMO_ASSEMBLEIA", false);
            this.$router.push("/termo/assembleia/" + sq_upload);
          } else {
            this.$store.commit("VALIDA_TERMO_ASSEMBLEIA", true);
            this.$router.push("/");
          }
        })
        .catch(() => {
          this.$store.commit("VALIDA_TERMO_ASSEMBLEIA", true);
          this.$router.push("/");
        });
    },
  },
};
</script>